import { INavData } from '../coreui/sidebar';

export const eFitNavItems: INavData[] = [
  {
    name: 'DASHBOARD',
    url: '/dashboard',
    icon: 'sli-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    // name: 'Efit Manager'
    name: 'FITNESSCLUBMANAGER' //'Fitness Club Manager'

  },
  {
    name: 'ACTIVITY',
    url: '/activity',
    icon: 'sli-badge', // activity
    children: [
      {
        name: 'FITNESSRESERVATIONS',
        url: '/fitness-reservations',
        icon: 'sli-event'// fitnessreservations
      },
      {
        name: 'MEMBERS',
        url: '/members',
        icon: 'cil-running'// members
      },
    ]
  },
  {
    name: 'Eclub',
    url: '/eclub',
    icon: 'sli-trophy', // eclub
    children: [
      {
        name: 'FITNESSSESSIONS',
        url: '/fitness-sessions',
        icon: 'sli-calendar'// fitnesssessions
      },
      {
        name: 'FITNESSCLASSES',
        url: '/fitness-classes',
        icon: 'cil-weightlifitng'// fitnessclasses
      },
      {
        name: 'COACHES',
        url: '/coaches',
        icon: 'cil-voice-over-record'// coaches
      },
      {
        name: 'FITNESSGOALS',
        url: '/fitness-goals',
        icon: 'sli-target'// fitnessgoals
      },
      {
        name: 'CLASSDURATIONS',
        url: '/class-durations',
        icon: 'sli-clock'// classdurations
      },
      {
        name: 'SPORTS',
        url: '/sports',
        icon: 'sli-energy'// sports
      },
      {
        name: 'INTENSITIES',
        url: '/intensities',
        icon: 'cil-layers'// intensities
      },
      {
        name: 'AGERANGES',
        url: '/age-ranges',
        icon: 'sli-people'// ageranges
      },
    ]
  },
  {
    name: 'WEBTV',
    url: '/webtv',
    icon: 'sli-screen-desktop', // webtv
    children: [
      {
        name: 'VIDEOS',
        url: '/videos',
        icon: 'sli-film'// videos
      },
      {
        name: 'VIDEOCATEGORIES',
        url: '/video-categories',
        icon: 'sli-folder'// videocategories
      },
      {
        name: 'VIDEOTYPES',
        url: '/video-types',
        icon: 'sli-book-open'// videotypes
      },
      {
        name: 'SHOWS',
        url: '/shows',
        icon: 'sli-umbrella'// shows
      },
      {
        name: 'LIVECHANNELS',
        url: '/live-channels',
        icon: 'sli-camrecorder'// livechannels
      },
    ]
  },
  {
    name: 'REVIEWS',
    url: '/reviews',
    icon: 'sli-bubbles', // reviews
    children: [
      {
        name: 'COMMENTS',
        url: '/comments',
        icon: 'sli-speech'// comments
      },
      {
        name: 'LIKES',
        url: '/likes',
        icon: 'sli-like'// likes
      },
      {
        name: 'FAVORITES',
        url: '/favorites',
        icon: 'sli-heart'// favorites
      },
      {
        name: 'RATINGS',
        url: '/ratings',
        icon: 'sli-star'// ratings
      },
      {
        name: 'REVIEWS',
        url: '/reviews',
        icon: 'sli-bubbles'// reviews
      },
    ]
  },
  {
    name: 'ADSERVING',
    url: '/adserving',
    icon: 'sli-briefcase', // adserving
    children: [
      {
        name: 'BANNERS',
        url: '/banners',
        icon: 'sli-puzzle '// banners
      },
      {
        name: 'BANNERTYPES',
        url: '/banner-types',
        icon: 'sli-folder-alt'// bannertypes
      },
      {
        name: 'CLICKS',
        url: '/clicks',
        icon: 'sli-cursor'// clicks
      },
      {
        name: 'BANNERPOSITIONS',
        url: '/banner-positions',
        icon: 'sli-grid'// bannerpositions
      },
      {
        name: 'IMPRESSIONS',
        url: '/impressions',
        icon: 'sli-printer'// impressions
      },
    ]
  },
  {
    name: 'OFFER',
    url: '/offer',
    icon: 'sli-present', // offer
    children: [
      {
        name: 'PACKS',
        url: '/packs',
        icon: 'sli-social-dropbox'// packs
      },
      {
        name: 'SUBSCRIPTIONS',
        url: '/subscriptions',
        icon: 'sli-basket-loaded'// subscriptions
      },
      {
        name: 'PACKAGETYPES',
        url: '/package-types',
        icon: 'sli-bag'// packagetypes
      },
      {
        name: 'PRICES',
        url: '/prices',
        icon: 'sli-tag'// prices
      },
      {
        name: 'SHARINGS',
        url: '/sharings',
        icon: 'sli-wallet'// sharings
      },
    ]
  },
  {
    name: 'ACCESS',
    url: '/access',
    icon: 'sli-lock', // access
    children: [
      {
        name: 'USERS',
        url: '/users',
        icon: 'sli-user'// users
      },
      {
        name: 'LOGS',
        url: '/logs',
        icon: 'sli-notebook'// logs
      },
      {
        name: 'COMPANIES',
        url: '/companies',
        icon: 'sli-organization'// companies
      },
    ]
  },
  {
    name: 'SETTINGS',
    url: '/settings',
    icon: 'sli-settings', // settings
    children: [
      {
        name: 'LANGUAGES',
        url: '/languages',
        icon: 'sli-flag'// languages
      },
      {
        name: 'COUNTRIES',
        url: '/countries',
        icon: 'sli-globe'// countries
      },
      {
        name: 'CITIES',
        url: '/cities',
        icon: 'sli-directions'// cities
      },
      {
        name: 'SETTINGS',
        url: '/settings',
        icon: 'sli-settings'// settings
      },
    ]
  },
  {
    name: 'STATISTICS',
    url: '/statistics',
    icon: 'sli-chart', // statistics
    children: [
      {
        name: 'VISITS',
        url: '/visits',
        icon: 'sli-bulb'// visits
      },
    ]
  },
  {
    name: 'NEWS',
    url: '/news',
    icon: 'cil-newspaper', // news
    children: [
      {
        name: 'POSTS',
        url: '/posts',
        icon: 'cil-short-text'// posts
      },
      {
        name: 'POSTTYPES',
        url: '/post-types',
        icon: 'cil-view-quilt'// posttypes
      },
    ]
  },
  
  {
    name: 'FILEMANGER',
    url: '/filer',
    icon: 'icon-folder',
    badge: {
      variant: 'success',
      text: 'NEW'
    }
  },
];

